import { render, staticRenderFns } from "./adminlist.vue?vue&type=template&id=546190c2&scoped=true"
import script from "./adminlist.vue?vue&type=script&lang=js"
export * from "./adminlist.vue?vue&type=script&lang=js"
import style0 from "./adminlist.vue?vue&type=style&index=0&id=546190c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546190c2",
  null
  
)

export default component.exports